import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { slugify } from '../../utils/slugify';
import { getTimeslotSummary } from '../../utils/formatDate';
import { CSSEvent } from '../../types/model';
import Card from '../Card';
import RegistrationStatus from '../RegistrationStatus';
import getBadges from './getBadges';
import EventPrice from '../../containers/BookEvent/EventPrice';

const Row = styled.span`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: var(--space-100);
`;

const EventIntro = styled.p`
  margin: 0 0 var(--space-50) 0;
  overflow-wrap: anywhere;
  // text-overflow: ellipsis;
  // overflow: hidden;
`;

const Event = ({
  event,
  slideShow = false,
}: {
  event: CSSEvent | null;
  slideShow?: boolean;
}) => {
  const { t } = useTranslation();
  if (!event) {
    return null;
  }

  const eventDetails = event.eventDetails;
  const timeslots = event.timeSlots || [];
  const time = getTimeslotSummary(timeslots, event.timeZone, t);

  const eventPath = `/${slugify(event.location.store.storeName)}/${
    event.urlId
  }/`;

  const showDots =
    eventDetails.eventIntroduction && eventDetails.eventIntroduction.length > 500
      ? '...'
      : '';

  const eventIntroText =
    eventDetails.eventIntroduction?.slice(0, 500) + showDots;

  return (
    <Card
      title={eventDetails.eventName}
      label={time}
      aspectRatioImageProps={{
        src: `${event.eventImagePath}?f=xs`,
        srcSet: `${event.eventImagePath}?f=xs 500w,${event.eventImagePath}?f=xxs 400w,${event.eventImagePath}?f=xxxs 300w`,
        ratio: 'square',
      }}
      badges={getBadges(event)}
      buttonText={t('event.gotoEvent', { eventName: eventDetails.eventName })}
      eventPath={eventPath}
      inSlideShow={slideShow}
      storeName={slideShow && event.location.store.storeName}
    >
      <EventIntro>{eventIntroText}</EventIntro>
      <Row>
        <EventPrice event={event}></EventPrice>
      </Row>
      <p>
        <RegistrationStatus event={event} />
      </p>
    </Card>
  );
};

export default Event;
